var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconParkOutlineMindMapping({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 28C9.06087 28 10.0783 27.5786 10.8284 26.8284C11.5786 26.0783 12 25.0609 12 24C12 22.9391 11.5786 21.9217 10.8284 21.1716C10.0783 20.4214 9.06087 20 8 20C6.93913 20 5.92172 20.4214 5.17157 21.1716C4.42143 21.9217 4 22.9391 4 24C4 25.0609 4.42143 26.0783 5.17157 26.8284C5.92172 27.5786 6.93913 28 8 28ZM42 8C42.5304 8 43.0391 7.78929 43.4142 7.41421C43.7893 7.03914 44 6.53043 44 6C44 5.46957 43.7893 4.96086 43.4142 4.58579C43.0391 4.21071 42.5304 4 42 4C41.4696 4 40.9609 4.21071 40.5858 4.58579C40.2107 4.96086 40 5.46957 40 6C40 6.53043 40.2107 7.03914 40.5858 7.41421C40.9609 7.78929 41.4696 8 42 8ZM42 26C42.5304 26 43.0391 25.7893 43.4142 25.4142C43.7893 25.0391 44 24.5304 44 24C44 23.4696 43.7893 22.9609 43.4142 22.5858C43.0391 22.2107 42.5304 22 42 22C41.4696 22 40.9609 22.2107 40.5858 22.5858C40.2107 22.9609 40 23.4696 40 24C40 24.5304 40.2107 25.0391 40.5858 25.4142C40.9609 25.7893 41.4696 26 42 26ZM42 44C42.5304 44 43.0391 43.7893 43.4142 43.4142C43.7893 43.0391 44 42.5304 44 42C44 41.4696 43.7893 40.9609 43.4142 40.5858C43.0391 40.2107 42.5304 40 42 40C41.4696 40 40.9609 40.2107 40.5858 40.5858C40.2107 40.9609 40 41.4696 40 42C40 42.5304 40.2107 43.0391 40.5858 43.4142C40.9609 43.7893 41.4696 44 42 44Z",
    stroke: "white",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32 6H20V42H32M12 24H32",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconParkOutlineMindMapping);
export default __webpack_public_path__ + "static/media/icon-park-outline_mind-mapping.abd2ad7ff00231561d6d5167e532d971.svg";
export { ForwardRef as ReactComponent };